import { render, staticRenderFns } from "./GutterQuestion.vue?vue&type=template&id=9da86c0a&scoped=true"
import script from "./GutterQuestion.vue?vue&type=script&lang=ts"
export * from "./GutterQuestion.vue?vue&type=script&lang=ts"
import style0 from "./GutterQuestion.vue?vue&type=style&index=0&id=9da86c0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da86c0a",
  null
  
)

export default component.exports